<app-header></app-header>
<div
    class="h-fit pt-[108px] relative"
    [class.pointer-events-none]="loading$ | async"
>
    <router-outlet></router-outlet>
    @if (loading$ | async) {
        <app-loading></app-loading>
    }
</div>
<app-footer></app-footer>
